module.exports = __webpack_public_path__ + "media/taishi_video.2056f713.mp4";